<template >
  <div class="priceManagement-page">
    <div class="all-content-container">
      <div class="screen-all-container">
        <div style="padding: 15px; border: 1px solid #ededed">
          <h3>{{ stageControlName }}</h3>
          <div class="right-btn">
            <el-button type="primary" @click="handleReturn"
              >返回阶段控制参数</el-button
            >
          </div>
        </div>
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
          class="el-tab_top"
        >
          <!-- <el-tab-pane
            label="外部设备"
            name="first"
            v-if="stageControlDecideStatus == 1"
          >
            <stageDeviceOutManagement></stageDeviceOutManagement>
          </el-tab-pane> -->
          <el-tab-pane label="阶段设备" name="second">
            <stageDeviceManagement></stageDeviceManagement>
          </el-tab-pane>
          <el-tab-pane label="阶段优先级" name="three">
            <stageControlPriorityManagement></stageControlPriorityManagement>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="pagination-container">
      <div class="pagination-content-container"></div>
    </div>
  </div>
</template>
<script>
import stageDeviceOutManagement from "@/views/growthModelManagement/growthModelStageDeviceOutManagement";
import stageDeviceManagement from "@/views/growthModelManagement/growthModelStageDeviceManagement";
import stageControlPriorityManagement from "@/views/growthModelManagement/growthModelStageControlPriorityManagement";

export default {
  components: {
    stageDeviceOutManagement,
    stageDeviceManagement,
    stageControlPriorityManagement,
  },
  data() {
    return {
      activeName: "second",
      stageControlId: "",
      stageControlName: "",
      stageControlDecideStatus: "",
    };
  },
  created() {
    this.stageControlId = this.$route.query.stageControlId;
    this.stageControlName = this.$route.query.stageControlName;

    if (this.$route.query.currentShow) {
      this.activeName = this.$route.query.currentShow;
    }
  },
  methods: {
    // Tab点击
    handleClick() {},
    // 返回
    handleReturn() {
      this.$router.push({
        name: `growthModelParamDeviceManagement`,
        query: {
          paramId: this.$route.query.paramId,
          paramType: this.$route.query.paramType,
          paramName: this.$route.query.paramName,
          paramUnit: this.$route.query.paramUnit,
          evnId: this.$route.query.evnId,
          evnName: this.$route.query.evnName,
          groupId: this.$route.query.groupId,
          controlType: this.$route.query.controlType,
          currentShow: "three",
        },
      });
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.el-button {
  line-height: 0 !important;
}
.el-table {
  overflow: auto !important;
}
.right-btn {
  margin-top: -30px;
  float: right;
  margin-right: 10px;
}
</style>